/**
 * Created by renlaydel on 02/11/2017.
 */
import keyBy from 'lodash/keyBy';
import { takeEvery, takeLatest, select, call, put } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { change, arrayRemove } from 'redux-form';
import uuid from 'uuid/v4';
import * as sagasCommon from '../../sagasCommon';
import * as apiCommon from '../../../services/apiCommon';
import * as apiTaxCode from '../../../services/tax/apiTaxCode';
import * as apiExchangeRate from '../../../services/exchange_rate/api_exchange_rate';
import * as apiPurchaseReceipt from '../../../services/purchase/receipt/api_purchase_receipt';
import * as apiPurchaseCommon from '../../../services/purchase/common/api_purchase';
import * as sagaInventoryReturn from '../../../sagas/purchase/return/saga_inventory_return';
import {
  GET_PURCHASE_RECEIPT,
  GET_PURCHASE_RECEIPT_LINE_TAX_GROUP,
  FETCH_LIST_PURCHASE_RECEIPT,
  SAVE_PURCHASE_RECEIPT,
  GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION,
  GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION,
  GET_PURCHASE_RECEIPT_EXCHANGE_RATE,
  GENERATE_PURCHASE_RETURN_DATA,
} from '../../../constants/constant_saga_types';
import {
  GENERATE_PURCHASE_RETURN,
  GENERATE_PURCHASE_RECEIPT,
} from '../../../constants/constant_action_types';
import { PurchaseReceiptForm as form } from '../../../constants/constant_form_names';
import { getFormLines } from '../../../components/admin/purchase/receipt/PurchaseReceiptSelector';
import { PURCHASE_RECEIPT } from '../../../constants/constant_doc_types';
import { getPreferenceSettings } from '../../../actions/actionCreatorsAdmin';
import { initializeItemLine, updateAvailableOnHand } from '../saga_purchase';
import {
  getPendingInventoryStatus,
  getOpenTransactionStatus,
} from '../../../common/selectors/selector_common';
import {
  getParticularPreferenceSettings,
} from '../../../common/selectors/preference';

export function* getPurchaseReceiptSaga(feathersApp) {
  yield takeEvery(GET_PURCHASE_RECEIPT, callGetPurchaseReceipt, feathersApp);
}

export function* callGetPurchaseReceipt(feathersApp, action) {
  try {
    const { user, purchase } = yield select();
    const { order } = purchase;
    const { id } = action;
    yield sagasCommon.showProgressDataById();
    yield put(getPreferenceSettings(['enable_item_part_quantity']));

    if (id) {
      const data = yield call(
        apiPurchaseReceipt.fetchPurchaseReceiptById,
        feathersApp,
        { id, user },
      );
      yield sagasCommon.doneDataById(data);
    } else if (order.generate_receipt) {
      yield put({ type: GENERATE_PURCHASE_RECEIPT, generateReceipt: false });
    } else {
      const openStatus = yield select(getOpenTransactionStatus);
      const data = {
        status_id: openStatus.id,
        status: openStatus,
        exchange_rate: 1,
      };
      yield sagasCommon.doneDataById(data);
    }
  } catch (e) {
    yield sagasCommon.showErrorDataById(e, true);
  }
}

export function* buildPurchaseReceipt(feathersApp, data) {
  let itemLines = [];
  const pendingStatus = yield select(getPendingInventoryStatus);
  const openStatus = yield select(getOpenTransactionStatus);
  const purchaseOrder = JSON.parse(JSON.stringify(data));
  purchaseOrder.lines.forEach((poLine) => {
    if (poLine.remaining_quantity > 0) {
      const line = {
        item_id: poLine.item_id,
        item: poLine.item,
        tax_group_id: poLine.tax_group_id,
        tax_group: poLine.tax_group,
        item_type: poLine.item.item_type,
        unit_cost: poLine.unit_cost,
        available_pre_receipt: poLine.available_pre_order,
        quantity: poLine.remaining_quantity,
        remaining_quantity: poLine.remaining_quantity,
        po_quantity: poLine.quantity,
        received_quantity:
          Number(poLine.quantity) - Number(poLine.remaining_quantity),
        tax_rate: poLine.tax_rate,
        total_ex_tax: poLine.total_ex_tax,
        total: poLine.total,
        po_line_id: poLine.id,
        line_id: uuid(),
        location: data.location,
        location_id: data.location_id,
        location_type: data.location.location_type_id,
        status: pendingStatus,
        status_id: pendingStatus.id,
      };

      if (poLine.item_uom) {
        line.item_uom = poLine.item_uom;
        line.item_uom_id = poLine.item_uom_id;
        line.uom_po_quantity = poLine.uom_quantity;
        line.uom_remaining_quantity = poLine.uom_remaining_quantity;
        line.uom_quantity =  poLine.uom_remaining_quantity;
        line.uom_unit_cost = poLine.uom_unit_cost;
        const uomRcvdQty = Number(poLine.uom_quantity) - Number(poLine.uom_remaining_quantity);
        line.uom_received_quantity = uomRcvdQty;
      }
      itemLines.push(line);
    }
  });

  const updatedItemLines = yield call(
    updateAvailableOnHand,
    feathersApp,
    itemLines,
    'available_pre_receipt',
  );

  return {
    subsidiary: purchaseOrder.subsidiary,
    subsidiary_id: purchaseOrder.subsidiary_id,

    location: purchaseOrder.location,
    location_id: purchaseOrder.location_id,
    location_type: purchaseOrder.location.location_type_id,

    supplier: purchaseOrder.supplier,
    supplier_id: purchaseOrder.supplier_id,

    currency: purchaseOrder.currency,
    currency_id: purchaseOrder.currency_id,

    exchange_rate: purchaseOrder.exchange_rate,
    status: openStatus,
    status_id: openStatus.id,

    dispatched_date: purchaseOrder.dispatched_date,
    purchase_order_id: purchaseOrder.id,
    purchase_order: {
      id: purchaseOrder.id,
      reference_id: purchaseOrder.reference_id,
    },

    lines: updatedItemLines,
  };
}
/**
 * SAVE_PURCHASE_RECEIPT
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* savePurchaseReceiptSaga(feathersApp) {
  yield takeEvery(SAVE_PURCHASE_RECEIPT, callSavePurchaseReceipt, feathersApp);
}

export function* callSavePurchaseReceipt(feathersApp, action) {
  try {
    const state = yield select();
    const { user } = state;
    const { data, redirectToView } = action;
    const { value: skip_low_qty } = getParticularPreferenceSettings(
      state,
      'enable_low_quantity_receipt',
      ['value'],
    ) || {};

    yield sagasCommon.showProgressSaveRecord();
    let result = yield call(
      apiPurchaseReceipt.savePurchaseReceipt,
      feathersApp,
      { user, data, skip_low_qty },
    );
    const id = result.id || result[0].id;

    yield put({ type: GET_PURCHASE_RECEIPT, id });

    if (redirectToView) {
      browserHistory.push(`/admin/purchase/receipt/view/${id}`);
    } else {
      browserHistory.push(`/admin/purchase/receipt/edit/${id}`);
    }
    yield sagasCommon.doneSaveRecord(result, 'Purchase receipt was saved');
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorSaveRecord(e);
  }
}

/**
 * FETCH_LIST_PURCHASE_RECEIPT
 *
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* fetchListPurchaseReceiptSaga(feathersApp) {
  yield takeLatest(
    FETCH_LIST_PURCHASE_RECEIPT,
    callFetchListPurchaseReceipt,
    feathersApp,
  );
}

export function* callFetchListPurchaseReceipt(feathersApp, action) {
  try {
    const { silent, filters } = action;
    yield sagasCommon.showProgressListTable(silent);
    const dataParams = {
      filters: { ...filters },
      list_type: PURCHASE_RECEIPT,
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(sagasCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (e) {
    yield sagasCommon.showErrorListTable(e);
  }
}
/**
 * GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION
 *
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* getPurchaseReceiptLineItemLocationSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION,
    callGetPurchaseReceiptLineItemLocation,
    feathersApp,
  );
}

export function* callGetPurchaseReceiptLineItemLocation(feathersApp, action) {
  try {
    const { locationId, itemId, index, itemUom } = action;
    const lineIndex = `lines[${index}]`;
    yield put(change(form, `lineIndex.isFetchingItemLocation`, true));
    const itemLocation = yield call(
      apiPurchaseCommon.getItemLocation,
      feathersApp,
      { itemId: itemId.split(':')[0], locationId },
    );

    if (itemLocation) {
      const initialItemLine = yield call(
        initializeItemLine,
        feathersApp,
        itemLocation,
      );
      const { taxGroup, taxRate, averageCost, available } = initialItemLine;
      if (itemUom) {
        const uomAvailableQty = Math.floor(available/itemUom.conversion_rate);
        yield put(
          change(
            form,
            `${lineIndex}.uom_available_pre_receipt`,
            Number(uomAvailableQty),
          ),
        );
        yield put(change(form, `${lineIndex}.uom_quantity`, 0));
        yield put(change(form, `${lineIndex}.uom_unit_cost`, averageCost*itemUom.conversion_rate));
      }
      yield put(
        change(form, `${lineIndex}.available_pre_receipt`, available || 0),
      );
      yield put(change(form, `${lineIndex}.tax_group`, taxGroup));
      yield put(change(form, `${lineIndex}.tax_group_id`, taxGroup.id));
      yield put(change(form, `${lineIndex}.tax_rate`, taxRate || 0));
      yield put(change(form, `${lineIndex}.total`, 0));
      yield put(change(form, `${lineIndex}.quantity`, 0));
      yield put(change(form, `${lineIndex}.unit_cost`, averageCost));
      yield put(change(form, `${lineIndex}.isFetchingItemLocation`, false));
    } else {
      yield call(resetLine, index);
      throw new Error('Item is not available in location');
    }
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorSaveRecord(e);
  }
}

function* resetLine(index) {
  yield put(arrayRemove(form, 'lines', index));
}

/**
 * GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION
 *
 *
 *
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* getAllPurchaseReceiptLinesItemLocationSaga(feathersApp) {
  yield takeLatest(
    GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION,
    callGetAllPurchaseReceiptLinesItemLocation,
    feathersApp,
  );
}

export function* callGetAllPurchaseReceiptLinesItemLocation(
  feathersApp,
  action,
) {
  try {
    const lines = yield select(getFormLines);
    const { locationId } = action;
    const itemLocationsQuery = lines.map((itemLine) => {
      const { item_id } = itemLine;
      return {
        item_id: item_id.split(':')[0],
        location_id: locationId,
      };
    });
    const itemLocations = yield call(
      apiPurchaseCommon.getItemLocations,
      feathersApp,
      itemLocationsQuery,
    );
    const indexedItemLocations = keyBy(
      itemLocations,
      ({ item_id, location_id }) => `${item_id}:${location_id}`,
    );
    let validItemLocations = true;
    const newLines = [];

    for (let line of lines) {
      const newLine = Object.assign({}, line);
      const itemId = line.item_id.split(':')[0];
      const lineItemLocationId = `${itemId}:${locationId}`;
      const itemLocation = indexedItemLocations[lineItemLocationId];

      if (itemLocation) {
        const initialItemLine = yield call(
          initializeItemLine,
          feathersApp,
          itemLocation,
        );
        const { taxGroup, taxRate, averageCost, available } = initialItemLine;
        newLine.available_pre_receipt = available;
        newLine.tax_group = taxGroup;
        newLine.tax_group_id = taxGroup.id;
        newLine.tax_rate = taxRate;
        newLine.total = 0;
        newLine.quantity = 0;
        newLine.unit_cost = averageCost;
        newLine.unit_price_location = 0;
        if (newLine.item_uom) {
          newLine.uom_unit_cost = averageCost*newLine.item_uom.conversion_rate;
        }
        newLines.push(newLine);
      } else {
        validItemLocations = false;
      }
    }

    yield put(change(form, 'lines', newLines));
    if (!validItemLocations) {
      throw new Error('Item is not available in location');
    }
  } catch (e) {
    yield sagasCommon.showErrorSaveRecord(e);
  }
}

export function* getPurchaseReceiptLineTaxGroupSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_RECEIPT_LINE_TAX_GROUP,
    callGetPurchaseReceiptLineTaxGroup,
    feathersApp,
  );
}

export function* callGetPurchaseReceiptLineTaxGroup(feathersApp, action) {
  try {
    const { taxGroupId, index } = action;
    const lineIndex = `lines[${index}]`;
    yield put(change(form, `${lineIndex}.isFetchingTaxGroup`, true));
    const taxRate = taxGroupId
      ? yield call(apiTaxCode.getTotalTaxRate, feathersApp, taxGroupId)
      : 0;
    yield put(change(form, `${lineIndex}.tax_rate`, taxRate || 0));
    yield put(change(form, `${lineIndex}.isFetchingTaxGroup`, false));
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorDataById(e);
  }
}
/**
 * GET_PURCHASE_RECEIPT_EXCHANGE_RATE
 *
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* getPurchaseReceiptExchangeRateSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_RECEIPT_EXCHANGE_RATE,
    callGetPurchaseOrderExchangeRate,
    feathersApp,
  );
}

export function* callGetPurchaseOrderExchangeRate(feathersApp, action) {
  try {
    const { currencyFromId, currencyToId, date } = action;
    const exchangeRate = yield call(
      apiExchangeRate.getExchangeRate,
      feathersApp,
      { currencyFromId, currencyToId, date },
    );
    yield put(
      change(form, 'exchange_rate', Number((exchangeRate || {}).rate) || 1),
    );
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorDataById(e);
  }
}

/**
 * TODO: GENERATE_PURCHASE_RETURN_DATA
 *
 *
 *
 *
 *
 *
 * @param {*} feathersApp
 */
export function* generateInventoryReturnSaga(feathersApp) {
  yield takeEvery(
    GENERATE_PURCHASE_RETURN_DATA,
    callGenerateInventoryReturn,
    feathersApp,
  );
}

export function* callGenerateInventoryReturn(feathersApp, action) {
  try {
    const { data, generateReturn } = action;
    yield put({ type: GENERATE_PURCHASE_RETURN, generateReturn });
    const inventoryReturn = yield call(
      sagaInventoryReturn.buildPurchaseReturn,
      feathersApp,
      data,
    );
    yield sagasCommon.doneDataById(inventoryReturn);
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorDataById(e);
  }
}
